import yowsClient from 'src/js/modules/service-client/yows-client';
import templates from 'src/js/modules/templates';

const fetchTemplateBySlug =
  ({ slug, locale }) =>
  async (dispatch) => {
    try {
      const { data } = await yowsClient.get().listSiteConcepts({ slug, locale, pageSize: 1 });
      const [template] = data.results || [];
      if (template) {
        dispatch(templates.actions.setSingleTemplate(template));
      }
    } catch (error) {
      console.error(error);
    }
  };

export default fetchTemplateBySlug;
